module.exports = __webpack_public_path__ + "static/media/run_2.3cfba38f.png";